import React from "react";
import Input from "Components/UI/Input";
import { useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
const boolStatus = [
  { id: "1", label: "Yes", value: true },
  { id: "0", label: "No", value: false },
];

const ContractTypeModal = ({ mode = "I", onSubmit, show = false, handleClose, contractTemplates = [] }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,
  } = useFormContext();

  return (
    <Modal show={show} onHide={handleClose} animation={true} centered>
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>{mode === "I" ? "Add Contract Type" : "Edit Contract Type"}</h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
          <div className="form-row">
            <div className="mb-3">
              <Input
                name="contractName"
                label="Contract Type"
                placeholder="Contract Type"
                className={`form-control ${errors.contractName ? "is-invalid" : ""}`}
                labelClassName="form-label"
                type="text"
                required={true}
                requiredMessage="Contract Type is requried"
              />
            </div>

             <div className="mb-3">
              <Input
                name="contractTemplate"
                type="commonSelect"
                placeholder="Contract Template"
                className={`form-control ${
                  errors.contractTemplate ? "is-invalid" : ""
                }`}
                label="Contract Template"
                labelClassName="form-label"
                optionData={contractTemplates}
                required={true}
                requiredMessage="Contract Template is required"
                onChange={(selectedOption) => {
                  console.log(selectedOption);
                  setValue("contractTemplate", selectedOption);
                  trigger("contractTemplate");
                }}
                value={watch("contractTemplate") === 0 ? "" : watch("contractTemplate")}

                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              />
            </div>

            <div className="mb-3">
              <Input
                name="isActive"
                type="commonSelect"
                placeholder="Status"
                className={`form-control ${
                  errors.isActive ? "is-invalid" : ""
                }`}
                label="Status"
                labelClassName="form-label"
                optionData={boolStatus}
                required={true}
                requiredMessage="Status is required"
                onChange={(selectedOption) => {
                  console.log(selectedOption);
                  setValue("isActive", selectedOption);
                  trigger("isActive");
                }}
                defaultValue={watch("isActive")}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              />
            </div>
          </div>
          <div className="text-end mt-3">
            <button type="submit" className="btn btn-primary">
              {mode === "I" ? "Add" : "Update"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

ContractTypeModal.propTypes = {
  mode: PropTypes.oneOf(["I", "E"]),
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  contractTemplates : PropTypes.array,
};

export default ContractTypeModal;
